import actions from '@/store/actions/promotionActions';
import * as types from '@/store/mutation-types';

/**
 * Define the module state
 *
 * @type {object}
 */
const moduleState = {
    activePromotion: null,
    dataHasBeenLoaded: false,
};

const mutations = {
    [types.STORE_PROMOTION](state, promotion) {
        state.activePromotion = promotion;
        state.dataHasBeenLoaded = true;
    },

    [types.WAIT_DATA_TO_BE_LOADED](state) {
        state.dataHasBeenLoaded = false;
    },
};

/**
 * Define the module getters
 *
 * @type {object}
 */
const getters = {
    promotion: (state) => state,
};

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state: moduleState,
};
